import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Chip, Typography } from '@material-ui/core';
import {
    formatValorMetrica,
    colorSeveridad,
    labelIndicador,
    resolveValorPresion,
} from '../../utils/HelpPreinforme';
import BarraRangos from './BarraRangos';
import preinformeStyles from './preinformeStyles';

/**
 * Tarjeta de una métrica del payload: valor + unidad, etiqueta del rango,
 * referencia, barra de rangos segmentada. El indicador PRESION es un caso
 * especial: el valor grande es la lectura completa "sistolica/diastolica"
 * (resolveValorPresion) en lugar de metrica.valor, y la barra de rangos
 * aclara que su referencia aplica solo a la sistolica, porque asi la
 * calcula el backend. Solo texto: ningún control de formulario.
 */
const MetricaCard = ({ metrica, preinforme }) => {
    const classes = preinformeStyles();
    const color = colorSeveridad(metrica.severidad);
    const esPresion = metrica.indicador === 'PRESION';
    const valorMostrado = esPresion
        ? (resolveValorPresion(preinforme) || '--')
        : formatValorMetrica(metrica.valor);

    return (
        <Paper className={classes.card} style={{ borderTopColor: color }}>
            <div className={classes.cardHeaderRow}>
                <Typography className={classes.cardTitulo} component="span">
                    {labelIndicador(metrica.indicador)}
                </Typography>
                {metrica.etiqueta && (
                    <Chip
                        size="small"
                        label={metrica.etiqueta}
                        className={classes.cardChip}
                        style={{ backgroundColor: color }}
                    />
                )}
            </div>

            <div className={classes.valueRow}>
                <Typography className={classes.valueNumber} component="span">
                    {valorMostrado}
                </Typography>
                {metrica.unidad && (
                    <Typography className={classes.valueUnit} component="span">
                        {metrica.unidad}
                    </Typography>
                )}
            </div>

            <BarraRangos
                segmentos={metrica.segmentos}
                posicionPct={metrica.posicionPct}
                referencia={metrica.referencia}
            />

            {metrica.referencia && (
                <Typography variant="caption" className={classes.referencia}>
                    {metrica.referencia}
                </Typography>
            )}

            {esPresion && (
                <Typography variant="caption" className={classes.nota}>
                    Rango de referencia calculado solo sobre la sistólica
                </Typography>
            )}
        </Paper>
    );
};

MetricaCard.propTypes = {
    metrica: PropTypes.shape({
        indicador: PropTypes.string,
        valor: PropTypes.number,
        unidad: PropTypes.string,
        etiqueta: PropTypes.string,
        referencia: PropTypes.string,
        severidad: PropTypes.number,
        posicionPct: PropTypes.number,
        segmentos: PropTypes.array,
    }).isRequired,
    preinforme: PropTypes.object,
};

MetricaCard.defaultProps = {
    preinforme: null,
};

export default MetricaCard;
